import { isPropertyDefined } from ".";
import { NonNilProperty } from "../types";

export function isPropertyDefinedCb<T, K extends keyof T>(
    field: K,
): (value: T | null | undefined) => value is NonNilProperty<T, K> {
    return (value: T | null | undefined): value is NonNilProperty<T, K> => isPropertyDefined(value, field);
}
